(() => {
  const validate = (select, { focus = false } = {}) => {
    if (!select) return true;
    const valid = Boolean(select.value);
    select.classList.toggle('is-invalid', !valid);
    const field = select.closest('[data-wemond-grind-field]');
    const error = field?.querySelector('[data-wemond-grind-error]');
    if (error) error.hidden = valid;
    select.setAttribute('aria-invalid', valid ? 'false' : 'true');
    if (!valid && focus) select.focus({ preventScroll: false });
    return valid;
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-wemond-grind-select]');
    if (select) validate(select);
  });

  document.addEventListener('submit', (event) => {
    const select = event.target?.querySelector?.('[data-wemond-grind-select]');
    if (select && !validate(select, { focus: true })) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('click', (event) => {
    const paymentButton = event.target.closest?.('.shopify-payment-button__button, shopify-accelerated-checkout button');
    if (!paymentButton) return;
    const form = paymentButton.closest('form');
    const select = form?.querySelector?.('[data-wemond-grind-select]');
    if (select && !validate(select, { focus: true })) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();

/* Desktop quick-add modal (2026-10-06): when the product has a real multi-value
   option (e.g. Gramaj 250 g / 100 g), place that variant picker and the Öğütüm
   field on one row. Detection uses the rendered Shopify option controls only
   (a select with 2+ options or a fieldset with 2+ radios) — never the title.
   Single-variant products render no variant picker, so Öğütüm stays full width.
   The picker element itself is moved (same approach as the PDP gram field), so
   Shopify's variant picker keeps morphing in place and the grind select stays
   inside the product form (validation and add-to-cart unchanged).
   Mobile (<750px) keeps the native stacked quick-add layout. */
(() => {
  const content = document.getElementById('quick-add-modal-content');
  if (!content || typeof MutationObserver !== 'function') return;
  const desktop = window.matchMedia('(min-width: 750px)');

  const hasMultiValueOption = (picker) =>
    [...picker.querySelectorAll('select')].some((select) => select.options.length > 1) ||
    [...picker.querySelectorAll('fieldset')].some((set) => set.querySelectorAll('input[type="radio"]').length > 1);

  const groupOptions = () => {
    if (!desktop.matches) return;
    const grind = content.querySelector('[data-wemond-grind-field]');
    const picker = content.querySelector('variant-picker');
    if (!grind || !picker || !hasMultiValueOption(picker)) return;
    let row = grind.closest('[data-wms-qa-option-row]');
    if (row && row.contains(picker)) return;
    if (!row) {
      row = document.createElement('div');
      row.className = 'wms-qa-option-row';
      row.setAttribute('data-wms-qa-option-row', '');
      grind.before(row);
      row.appendChild(grind);
    }
    row.prepend(picker);
  };

  new MutationObserver(groupOptions).observe(content, { childList: true, subtree: true });
})();
